//TODO: edit as per API req,response
import actions from '@/store/modules/k8/node/node.actions';
export interface State {
  currentTemplate: any;
}

const initialState: State = {
  currentTemplate: {}
};

export default {
  namespaced: true,
  actions: actions,
  state: initialState
};
